import getDOMfromString from '../../../helpers/getDOMfromString';
import classes from './styles.module.css';

/**
 * Generates arrow buttons for carousel
 *
 * @param {Object} config - options for btns
 * @returns {HTMLElement|string} - button/button string
 */
const createArrowBtn = config => {
    const {type = 'left', customClasses = [], color = 'white', onClick, htmlStr = false, label} = config ?? {};
    const customClassesStr = Array.isArray(customClasses) ? customClasses.join(' ') : '';

    const btnStr = `<button type="button" aria-label="${label}" title="${label}" class="${classes[type]} ${customClassesStr}"><svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.77299 12.8334L10.3033 12.3031L14.546 8.06042L13.4853 6.99976L9.77299 10.7121L6.06068 6.99976L5.00002 8.06042L9.24266 12.3031L9.77299 12.8334Z" fill="${color}"/>
</svg></button>`;

    if (htmlStr) {
        return btnStr;
    }

    const btn = getDOMfromString(btnStr);

    if (onClick) {
        btn.onclick = onClick;
    }

    return btn;
};

export default createArrowBtn;
